import { useEffect, useState } from "react";
import { DateTime } from "luxon";
import { getDayOfYear } from "date-fns";

const getWebinarDay = (date, time) => {
  if (!date || !time) return null;

  const combinedDateTime = `${date.trim()} ${time.trim()}`;

  const dt = DateTime.fromFormat(combinedDateTime, "yyyy-MM-dd hh:mm a", {
    zone: "Asia/Kolkata",
  });

  if (!dt.isValid) {
    console.error("Invalid webinar date/time:", dt.invalidExplanation);
    return null;
  }

  return dt.toFormat("cccc"); // e.g., "Tuesday"
};

const WebinarCountdown = ({
  webinarDate, // e.g., "2025-06-10"
  webinarStartTime, // e.g., "12:55 PM"
  onCountdownUpdate,
}) => {
  const [timeLeft, setTimeLeft] = useState("");
  const [webinarDay, setWebinarDay] = useState("");

  useEffect(() => {
    let getDay = getWebinarDay(webinarDate, webinarStartTime);
    setWebinarDay(getDay);
    if (!webinarDate || !webinarStartTime) return;

    const combinedDateTime = `${webinarDate.trim()} ${webinarStartTime.trim()}`;
    const targetDateTimeIST = DateTime.fromFormat(
      combinedDateTime,
      "yyyy-MM-dd hh:mm a",
      { zone: "Asia/Kolkata" }
    );

    if (!targetDateTimeIST.isValid) {
      console.error("Invalid DateTime:", targetDateTimeIST.invalidExplanation);
      setTimeLeft("Invalid webinar date or time.");
      return;
    }

    const updateCountdown = () => {
      const now = DateTime.now(); // user's local time
      const diff = targetDateTimeIST
        .diff(now, ["days", "hours", "minutes", "seconds"])
        .toObject();

      if (targetDateTimeIST <= now) {
        setTimeLeft("Webinar is Live!");
        return;
      }

      const { days, hours, minutes, seconds } = diff;

      if (
        [days, hours, minutes, seconds].every(
          (val) => typeof val === "number" && !isNaN(val)
        )
      ) {
        setTimeLeft(
          `Will Be Live in ${Math.floor(days)} Days, ${Math.floor(
            hours
          )} Hours, ${Math.floor(minutes)} Minutes, ${Math.floor(
            seconds
          )} Seconds.`
        );

        if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
          onCountdownUpdate?.(0);
        }
      }
    };

    updateCountdown(); // initial call
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [webinarDate, webinarStartTime]);

  return <p>{timeLeft}</p>;
};

export default WebinarCountdown;
